import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrendingUpOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "icon / ionicons / outline / trending-up-outline",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.125 5.625C13.125 5.27982 13.4048 5 13.75 5H18.125C18.4702 5 18.75 5.27982 18.75 5.625V10C18.75 10.3452 18.4702 10.625 18.125 10.625C17.7798 10.625 17.5 10.3452 17.5 10V6.25H13.75C13.4048 6.25 13.125 5.97018 13.125 5.625Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)_2",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.9419 5.80806C18.186 6.05214 18.186 6.44786 17.9419 6.69194L12.576 12.0579C12.576 12.0579 12.5759 12.0579 12.5759 12.058C12.4018 12.2321 12.1951 12.3702 11.9676 12.4645C11.7401 12.5587 11.4963 12.6072 11.25 12.6072C11.0037 12.6072 10.7599 12.5587 10.5324 12.4645C10.3049 12.3702 10.0981 12.2321 9.92402 12.0579L7.94204 10.0759L7.94199 10.0759C7.88395 10.0178 7.81505 9.97177 7.73921 9.94036C7.66337 9.90894 7.58209 9.89277 7.5 9.89277C7.41791 9.89277 7.33663 9.90894 7.26079 9.94036C7.18495 9.97177 7.11605 10.0178 7.05801 10.0759L7.05796 10.0759L2.31694 14.8169C2.07286 15.061 1.67714 15.061 1.43306 14.8169C1.18898 14.5729 1.18898 14.1771 1.43306 13.9331L6.17402 9.19209C6.34814 9.01794 6.55486 8.87979 6.78237 8.78553C7.00988 8.69128 7.25374 8.64277 7.5 8.64277C7.74626 8.64277 7.99012 8.69128 8.21763 8.78553C8.44514 8.87979 8.65186 9.01794 8.82598 9.19209L10.808 11.1741L10.808 11.1741C10.866 11.2322 10.935 11.2782 11.0108 11.3096C11.0866 11.3411 11.1679 11.3572 11.25 11.3572C11.3321 11.3572 11.4134 11.3411 11.4892 11.3096C11.565 11.2782 11.634 11.2322 11.692 11.1741L11.692 11.1741L17.0581 5.80806C17.3021 5.56398 17.6979 5.56398 17.9419 5.80806Z",
			fill: "white"
		})]
	})
});
export default SvgTrendingUpOutline;
